'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var art = exports.art = [{
    columnCategories: [{
        headerLink: '/c/art/1/',
        headerText: 'Top Categories',
        links: [{
            route: '/c/drawings/8/',
            text: 'Drawings'
        }, {
            route: '/c/mixed-media/9/',
            text: 'Mixed Media & Collages'
        }, {
            route: '/c/paintings/10/',
            text: 'Paintings'
        }, {
            route: '/c/photography/11/',
            text: 'Photography'
        }, {
            route: '/c/prints/12/',
            text: 'Prints & Multiples'
        }, {
            route: '/c/scrolls-fans/13/',
            text: 'Scrolls, Screens & Fan Paintings'
        }, {
            route: '/c/sculptures-statues-carvings/14/',
            text: 'Sculptures'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Featured Artists',
        links: [{
            route: '/c/art/pablo-picasso/1/18755/',
            text: 'Pablo Picasso'
        }, {
            route: '/c/art/marc-chagall/1/15935/',
            text: 'Marc Chagall'
        }, {
            route: '/c/art/andy-warhol/1/1705/',
            text: 'Andy Warhol'
        }, {
            route: '/c/art/jean-michel-basquiat/1/11965/',
            text: 'Jean-Michel Basquiat'
        }, {
            route: '/c/art/roy-lichtenstein/1/21418/',
            text: 'Roy Lichtenstein'
        }, {
            route: '/c/art/keith-haring/1/14133/',
            text: 'Keith Haring'
        }, {
            route: '/c/art/francis-bacon/1/7794/',
            text: 'Francis Bacon'
        }, {
            route: '/c/art/frank-stella/1/7962/',
            text: 'Frank Stella'
        }]
    }]
}];
var jewelry = exports.jewelry = [{
    columnCategories: [{
        headerText: 'Top Categories',
        links: [{
            route: '/c/bracelets/89/',
            text: 'Bracelets'
        }, {
            route: '/c/brooches-pins/90/',
            text: 'Brooches & Pins'
        }, {
            route: '/c/cufflinks/91/',
            text: 'Cufflinks & Tie Pins'
        }, {
            route: '/c/earrings/92/',
            text: 'Earrings'
        }, {
            route: '/c/loose-stones-beads/94/',
            text: 'Loose Stones & Beads'
        }, {
            route: '/c/necklaces-pendants/95/',
            text: 'Necklaces & Pendants'
        }, {
            route: '/c/rings/96/',
            text: 'Rings'
        }, {
            route: '/c/watches/97/',
            text: 'Watches'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Featured Makers',
        links: [{
            route: '/c/jewelry/cartier/6/3899/',
            text: 'Cartier'
        }, {
            route: '/c/jewelry/chanel/6/4017/',
            text: 'Chanel'
        }, {
            route: '/c/jewelry/rolex/6/21252/',
            text: 'Rolex'
        }, {
            route: '/c/jewelry/bulova/6/3513/',
            text: 'Bulova'
        }, {
            route: '/c/jewelry/chopard/6/4393/',
            text: 'Chopard'
        }, {
            route: '/c/jewelry/swarovski/6/23012/',
            text: 'Swarovski'
        }, {
            route: '/c/jewelry/bulgari/6/3512/',
            text: 'Bulgari'
        }, {
            route: '/c/jewelry/patek-philippe/6/18874/',
            text: 'Patek Philippe'
        }]
    }]
}];
var asian = exports.asian = [{
    columnCategories: [{
        headerLink: '/c/asian/158/',
        headerText: 'Top Categories',
        links: [{
            route: '/c/art/asian/1/158/',
            text: 'Art'
        }, {
            route: '/c/collectibles/asian/2/158/',
            text: 'Collectibles'
        }, {
            route: '/c/fashion/asian/3/158/',
            text: 'Fashion'
        }, {
            route: '/c/furniture/asian/4/158/',
            text: 'Furniture'
        }, {
            route: '/c/jewelry/asian/6/158/',
            text: 'Jewelry'
        }, {
            route: '/c/serveware-flatware-services/asian/86/158/',
            text: 'Serveware, Flatware & Services'
        }, {
            route: '/c/vases-pots/asian/87/158/',
            text: 'Vases & Garnitures'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Browse By Origin',
        links: [{
            route: '/c/chinese/162/',
            text: 'Chinese Antiques'
        }, {
            route: '/c/indian/176/',
            text: 'Indian Antiques'
        }, {
            route: '/c/japanese/163/',
            text: 'Japanese Antiques'
        }, {
            route: '/c/korean/164/',
            text: 'Korean Antiques'
        }, {
            route: '/c/persian/185/',
            text: 'Persian Antiques'
        }, {
            route: '/c/southeast-asian/169/',
            text: 'Southeast Asian Antiques'
        }, {
            route: '/c/tibetan/168/',
            text: 'Tibetan Antiques'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Featured',
        links: [{
            route: '/c/asian/bronze/158/25739/',
            text: 'Bronze'
        }, {
            route: '/c/asian/cloisonne/158/25757/',
            text: 'Cloisonne'
        }, {
            route: '/c/han-dynasty/245/',
            text: 'Han Dynasty'
        }, {
            route: '/c/jewelry/jade/6/25797/',
            text: 'Jade Jewelry'
        }, {
            route: '/c/asian/porcelain/158/25849/',
            text: 'Porcelain'
        }, {
            route: '/c/ming-dynasty/246/',
            text: 'Ming Dynasty'
        }, {
            route: '/c/qing-dynasty/251/',
            text: 'Qing Dynasty'
        }, {
            route: '/c/prints/woodblock/12/25903/',
            text: 'Woodblock Prints'
        }]
    }]
}];
var furniture = exports.furniture = [{
    columnCategories: [{
        headerText: 'Top Categories',
        links: [{
            route: '/c/bedroom-furniture/56/',
            text: 'Bedroom Furniture'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"armoire%20OR%20bookcase%20OR%20etagere%20OR%20%5C"display%20case%5C"%20OR%20chest%20OR%20trunk%20OR%20commode%20OR%20drawers%20OR%20credenza%20OR%20cupboard%20OR%20%5C"pie%20safe%5C"%20OR%20%5C"linen%20press%5C"%20OR%20%5C"liquor%20cabinet%5C"%20OR%20%5C"dry%20bar%5C"%20OR%20sideboard%20OR%20buffet","status":"online"%7D',
            text: 'Cabinets & Case Pieces'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"stool%20OR%20bench%20OR%20seat%20OR%20pews%20OR%20settee%20OR%20chair%20OR%20armchair%20OR%20bergere%20OR%20klismos%20OR%20chaise%20OR%20daybed%20OR%20ottoman%20OR%20pouf%20OR%20%5C"porch%20glider%5C"%20OR%20sofa%20OR%20canape%20OR%20loveseat","status":"online"%7D',
            text: 'Seating'
        }, {
            route: '/c/tables/69/',
            text: 'Tables'
        }]
    }, {
        headerLink: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"stool%20OR%20bench%20OR%20seat%20OR%20pews%20OR%20settee%20OR%20chair%20OR%20armchair%20OR%20bergere%20OR%20klismos%20OR%20chaise%20OR%20daybed%20OR%20ottoman%20OR%20pouf%20OR%20%5C"porch%20glider%5C"%20OR%20sofa%20OR%20canape%20OR%20loveseat","status":"online"%7D',
        headerText: 'Seating',
        links: [{
            route: '/c/benches-stools/57/',
            text: 'Benches & Stools'
        }, {
            route: '/c/chairs/61/',
            text: 'Chairs'
        }, {
            route: '/c/sofas-chaises/68/',
            text: 'Sofas & Canapes'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Cabinets & Case Pieces',
        links: [{
            route: '/c/armoires-wardrobes/55/',
            text: 'Armoires & Wardrobes'
        }, {
            route: '/c/bookcases/58/',
            text: 'Bookcases, Etageres & Display Cases'
        }, {
            route: '/c/dressers-vanities/65/',
            text: 'Chests of Drawers & Commodes'
        }, {
            route: '/c/sideboards-buffets/67/',
            text: 'Sideboards & Buffets'
        }]
    }, {
        headerText: 'Tables',
        links: [{
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"coffee%20table","status":"online"%7D',
            text: 'Coffee Tables'
        }, {
            route: '/c/desks/63/',
            text: 'Desks & Writing Tables'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"dining%20table","status":"online"%7D',
            text: 'Dining Tables'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Browse By Style',
        links: [{
            route: '/c/furniture/art-deco/4/253/',
            text: 'Art Deco'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"chippendale"%2C"status"%3A"online"%2C"category_id"%3A"4"%7D',
            text: 'Chippendale'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"federal%20style"%2C"status"%3A"online"%2C"category_id"%3A"4"%7D',
            text: 'Federal Style'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"hollywood%20regency"%2C"status"%3A"online"%2C"category_id"%3A"4"%7D',
            text: 'Hollywood Regency'
        }, {
            route: '/c/furniture/mid-century-modern/4/265/',
            text: 'Mid-Century Modern'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"mission%20style"%2C"status"%3A"online"%2C"category_id"%3A"4"%7D',
            text: 'Mission Style'
        }, {
            route: '/c/furniture/rococo/4/260/',
            text: 'Rococo'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"queen%20anne"%2C"status"%3A"online"%2C"category_id"%3A"4"%7D',
            text: 'Queen Anne'
        }, {
            route: '/c/furniture/victorian/4/275/',
            text: 'Victorian'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Featured Makers',
        links: [{
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"Eames"%2C"status"%3A"online"%2C"category_id"%3A"4"%7D',
            text: 'Eames'
        }, {
            route: '/c/furniture/herman-miller/4/10385/',
            text: 'Herman Miller'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"hans%20wegner"%2C"status"%3A"online"%2C"category_id"%3A"4"%7D',
            text: 'Hans Wegner'
        }, {
            route: '/c/furniture/paul-evans/4/19010/',
            text: 'Paul Evans'
        }, {
            route: '/c/furniture/george-nelson/4/8661/',
            text: 'George Nelson'
        }, {
            route: '/c/furniture/stickley/4/9563/',
            text: 'Stickley'
        }, {
            route: '/c/furniture/milo-baughman/4/17579/',
            text: 'Milo Baughman'
        }]
    }]
}];
var collectibles = exports.collectibles = [{
    columnCategories: [{
        headerText: 'Top Categories',
        links: [{
            route: '/c/posters-signs-advertising/38/',
            text: 'Advertisements & Trade Signs'
        }, {
            route: '/c/books-magazines-papers/20/',
            text: 'Books, Magazines & Papers'
        }, {
            route: '/c/coins-medals-money/24/',
            text: 'Coins, Currency & Stamps'
        }, {
            route: '/c/figurines/28/',
            text: 'Figurines'
        }, {
            route: '/c/maps-atlases/33/',
            text: 'Maps, Globes & Atlases'
        }, {
            route: '/c/religious-spiritual-objects/39/',
            text: 'Religious & Spiritual Objects'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"tobacco%20OR%20%5C"smoking%20sign%5C"%20OR%20cigar%20OR%20humidor%20OR%20zippo%20OR%20lighter%20OR%20%5C"matchbook%5C"%20OR%20%5C"match%20holder%5C"%20OR%20%5C"matchbox%5C"%20OR%20%5C"pipe%5C"%20OR%20%5C"ashtray%5C"%20OR%20cigarette%20OR%20snuff","status":"online"%7D',
            text: 'Tobacciana'
        }, {
            route: '/c/toys-trains-games/46/',
            text: 'Toys, Dolls & Games'
        }, {
            route: '/c/militaria-armor/35/',
            text: 'Weapons & Armor'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Memorabilia',
        links: [{
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"esso%20OR%20texaco%20OR%20%5C"standard%20oil%5C"%20OR%20shell%20OR%20mobil%20OR%20gulf%20OR%20sinclair%20OR%20%5C"gas%20globe%5C"%20OR%20%5C"gas%20pump%5C"%20OR%20%5C"gas%20sign%5C"%20OR%20%5C"service%20sign%5C"%20OR%20%5C"oil%20bottle%5C"%20OR%20%5C"oil%20can%5C"%20OR%20%5C"road%20map%5C"%20OR%20petroliana%20OR%20petrol","status":"online"%7D',
            text: 'Automobilia & Petroliana'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"badge%20OR%20medal%20-military%20-war%20-service","status":"online"%7D',
            text: 'Badges & Medals'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"beer%20OR%20budweiser%20OR%20hamms%20OR%20schlitz%20OR%20pabst%20OR%20blatz%20OR%20miller%20OR%20%5C"bottle%20opener%5C"","status":"online"%7D',
            text: 'Beer Signs & Breweriana'
        }, {
            route: '/c/carnivals-circuses/23/',
            text: 'Carnival & Circus Collectibles'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"military%20OR%20%5C"fixed%20blade%20knife%5C"%20OR%20%5C"air%20force%5C"%20OR%20navy%20OR%20marines%20OR%20%5C"revolutionary%20war%5C"%20OR%20%5C"vietnam%20war%5C"%20OR%20%5C"civil%20war%5C"%20OR%20%5C"korean%20war%5C"%20OR%20%5C"world%20war%5C"%20OR%20wartime","status":"online"%7D',
            text: 'Military & War'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"movie%20OR%20%5C"shirley%20temple%5C"%20OR%20%5C"mickey%20mouse%5C"%20OR%20%5C"marilyn%20monroe%5C"%20OR%20%5C"john%20wayne%5C"%20OR%20%5C"james%20dean%5C"%20OR%20%5C"audrey%20hepburn%5C"%20OR%20movie%20OR%20%5C"animation%20cel%5C"%20OR%20%5C"star%20wars%5C"%20OR%20%5C"star%20trek%5C"%20OR%20%5C"james%20bond%5C"%20OR%20godzilla%20OR%20ghostbusters%20OR%20%5C"alfred%20hitchcock%5C"%20OR%20soundtrack%20OR%20%5C"vhs%20tape%5C"","status":"online"%7D',
            text: 'Movie & TV'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"%5C"concert%20ticket%5C"%20OR%20abba%20OR%20%5C"sheet%20music%5C"%20OR%20%5C"player%20piano%5C"%20OR%20%5C"pearl%20jam%5C"%20OR%20music%20OR%20%5C"michael%20jackson%5C"%20OR%20metronome%20OR%20kiss%20OR%20jukebox%20OR%20%5C"jimi%20hendrix%5C"%20OR%20woodstock%20OR%20%5C"frank%20sinatra%5C"%20OR%20%5C"elvis%20presley%5C"%20OR%20%5C"elton%20john%5C"%20OR%20%5C"david%20bowie%5C"%20OR%20beatles%20OR%20%5C"concert%20shirt%5C"","status":"online"%7D',
            text: 'Music & Concert'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"railroad%20OR%20%5C"conductor%20badge%5C"%20OR%20%5C"fireman%20badge%5C"%20OR%20%5C"engineer%20badge%5C"%20OR%20%5C"baggage%20tag%5C"%20OR%20%5C"builder%20plate%5C"%20OR%20holloware%20OR%20spittoon%20OR%20%5C"new%20york%20central%5C"%20OR%20%5C"southern%20pacific%5C"%20OR%20%5C"baltimore%20and%20ohio%5C"%20OR%20%5C"pennsylvania%20central%5C"%20OR%20%5C"sante%20fe%5C"%20OR%20%5C"norfolk%20and%20western%5C"%20OR%20%5C"denver%20and%20rio%20grande%5C"%20OR%20%5C"locomotive%5C"%20OR%20%5C"steam%20whistle%5C"%20OR%20%5C"conductor%20hat%5C"%20OR%20%5C"union%20pacific%5C"%20OR%20%5C"boston%20and%20maine%5C"%20OR%20lackawanna%20OR%20%5C"train%20horn%5C"%20OR%20railway%20OR%20%5C"penn%20central%5C"","status":"online"%7D',
            text: 'Railroadiana'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"baseball%20OR%20football%20OR%20soccer%20OR%20fishing%20OR%20basketball%20OR%20%5C"rookie%20card%5C"%20OR%20%5C"world%20series%5C"%20OR%20%5C"babe%20ruth%5C"%20OR%20%5C"hank%20aaron%5C"%20OR%20%5C"reggie%20jackson%5C"%20OR%20%5C"mickey%20mantle%5C"%20OR%20%5C"joe%20dimaggio%5C"%20OR%20%5C"ty%20cobb%5C"%20OR%20%5C"yogi%20berra%5C"%20OR%20%5C"lou%20gehrig%5C"%20OR%20%5C"bennis%20rodman%5C"%20OR%20%5C"kobe%20bryant%5C"%20OR%20%5C"magic%20johnson%5C"%20OR%20%5C"joe%20namath%5C"%20OR%20%5C"tom%20brady%5C"%20OR%20%5C"walter%20payton%5C"","status":"online"%7D',
            text: 'Sports'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Machines & Electronics',
        links: [{
            route: '/c/banks-registers-vending/18/',
            text: 'Banks, Registers & Adding Machines'
        }, {
            route: '/c/cameras-electronics/21/',
            text: 'Cameras & Photographica'
        }, {
            route: '/c/tools-hardware-locks/45/',
            text: 'Home Hardware, Tools & Locks'
        }, {
            route: '/c/music-instruments-gear/37/',
            text: 'Musical Instruments & Music Stands'
        }, {
            route: '/c/ink-writing-painting/32/',
            text: 'Pens & Writing Instruments'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"radio%20OR%20shortwave%20OR%20%5C"atwater%20kent%5C"%20OR%20crosley%20OR%20emerson%20OR%20philco%20OR%20zenith%20OR%20rca%20OR%20stromberg%20OR%20microphone%20OR%20amplifier%20OR%20gramophone%20OR%20phonograph%20OR%20telegraph%20OR%20jukebox%20OR%20stereo%20OR%20turntable%20OR%20speaker%20OR%20%5C"record%20player%5C"%20OR%20%5C"walkie%20talkie%5C"%20OR%20audio","status":"online"%7D',
            text: 'Radios & Audio Equipment'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"apothecary%20OR%20armillary%20OR%20astrolabe%20OR%20barometer%20OR%20compass%20OR%20engineering%20OR%20laboratory%20OR%20dental%20OR%20medical%20OR%20microscope%20OR%20scale%20OR%20surveyor%20OR%20telescope%20OR%20thermometer%20OR%20hygrometer%20OR%20surgery%20OR%20%5C"slide%20rule%5C"%20OR%20%5C"drafting%20tool%5C"%20OR%20calculator%20OR%20science","status":"online"%7D',
            text: 'Scientific & Medical Objects'
        }]
    }]
}];
var home = exports.home = [{
    columnCategories: [{
        headerLink: '/c/home-garden/5/',
        headerText: 'Home',
        links: [{
            route: '/c/barware/71/',
            text: 'Barware'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"%5C"break%20boxes%5C"%20OR%20%5C"cookie%20jar%5C"%20OR%20%5C"candy%20jar%5C"%20OR%20%5C"canister%5C"%20Or%20%5C"spice%20jar%5C"%20OR%20%5C"tea%20caddy%5C"%20OR%20pitcher%20OR%20jug%20OR%20%5C"pantry%20box%5C"%20OR%20%5C"poacher%5C"%20OR%20%5C"dutch%20oven%5C"%20OR%20%5C"double%20boiler%5C"%20OR%20%5C"saucepan%5C"%20OR%20%5C"skillet%5C"%20OR%20%5C"frying%20pan%5C"%20OR%20%5C"stockpot%5C"%20OR%20roaster%20OR%20%5C"coffee%20grinder%5C"%20OR%20%5C"tea%20kettle%5C"%20OR%20toaster","status":"online"%7D',
            text: 'Kitchenware'
        }, {
            route: '/c/lighting/81/',
            text: 'Lighting'
        }, {
            route: '/c/serveware-flatware-services/86/',
            text: 'Serveware, Flatware & Services'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"sewing%20OR%20button%20OR%20%5C"pin%20cushion%5C"OR%20%5C"tape%20measure%5C"%20OR%20thimble%20OR%20crochet%20OR%20knitting%20OR%20singer","status":"online"%7D',
            text: 'Sewing, Weaving & Knitting'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Decorative Objects',
        links: [{
            route: '/c/baskets-containers/72/',
            text: 'Baskets & Containers'
        }, {
            route: '/c/birdhouses/19/',
            text: 'Bird Cages & Birdhouses'
        }, {
            route: '/c/clocks/74/',
            text: 'Clocks'
        }, {
            route: '/c/mirrors/83/',
            text: 'Mirrors'
        }, {
            route: '/c/rugs-carpets/85/',
            text: 'Rugs & Carpets'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"bedspread%20OR%20blanket%20OR%20quilt%20OR%20napkin%20OR%20tablecloth%20OR%20%5C"tea%20towel%5C"%20OR%20embroidery%20OR%20fabric%20OR%20feedsack%20OR%20handkerchief%20OR%20sampler%20OR%20textile","status":"online"%7D',
            text: 'Textiles'
        }, {
            route: '/c/vases-pots/87/',
            text: 'Vases & Garnitures'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Garden & Architectural Elements',
        links: [{
            route: '/c/garden-ornaments/79/',
            text: 'Garden Ornaments'
        }, {
            route: '/c/garden-furniture/66/',
            text: 'Garden Furniture'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"fountain%20OR%20birdbath","status":"online"%7D',
            text: 'Fountains & Birdbaths'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"column%20OR%20pedestal%20-lamp%20-bowl%20-table%20-pitcher%20-dish%20-plate%20-vase%20-desk%20-clock%20-pot%20-jug%20-cake","status":"online"%7D',
            text: 'Columns & Pedestals'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"finial","status":"online"%7D',
            text: 'Finials'
        }, {
            route: '/c/fireplaces-mantels/77/',
            text: 'Fireplaces & Mantels'
        }, {
            route: '/c/planters-urns-jardinieres/84/',
            text: 'Planters'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Featured',
        links: [{
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"tiffany%20OR%20swarovski%20OR%20steuben%20OR%20moser%20OR%20loetz%20OR%20lalique%20OR%20imperial%20OR%20fenton%20OR%20daum%20OR%20blenko%20OR%20baccarat%20OR%20murano%20OR%20%5C"stained%20glass%5C"%20OR%20%5C"art%20glass%5C"","status":"online"%7D',
            text: 'Art Glass'
        }, {
            route: '/c/lalique/14553/',
            text: 'Lalique'
        }, {
            route: '/c/tiffany-studios/23547/',
            text: 'Tiffany Studios'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"meissen","status":"online"%7D',
            text: 'Meissen'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"herend","status":"online"%7D',
            text: 'Herend'
        }, {
            route: '/c/buccellati/3503/',
            text: 'Buccellati'
        }, {
            route: '/c/steuben/22705/',
            text: 'Steuben'
        }]
    }]
}];
var fashion = exports.fashion = [{
    columnCategories: [{
        headerText: 'Clothing',
        links: [{
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"gown%20OR%20dress%20-doll%20-canvas%20-sword%20-lithograph%20-ring%20-watch%20-bayonet%20-blade%20-stone%20-sculpture","status":"online"%7D',
            text: 'Dresses & Gowns'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"coat%20OR%20jacket%20-tree%20-rack%20-ring%20-lithograph","status":"online"%7D',
            text: 'Jackets & Coats'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"shirt%20OR%20blouse","status":"online"%7D',
            text: 'Shirts & Blouses'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"pants%20OR%20trousers","status":"online"%7D',
            text: 'Pants & Trousers'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"kimono%20OR%20robe"%2C"status"%3A"online"%2C"category_id"%3A"3"%7D',
            text: 'Robes & Kimonos'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"skirt"%2C"status"%3A"online"%2C"category_id"%3A"3"%7D',
            text: 'Skirts'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"suit%20OR%20ensemble"%2C"status"%3A"online"%2C"category_id"%3A"3"%7D',
            text: 'Suits & Ensembles'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"sweater","status":"online"%7D',
            text: 'Sweaters'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"vest"%2C"status"%3A"online"%2C"category_id"%3A"3"%7D',
            text: 'Vests'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Accessories',
        links: [{
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"chatelain%20OR%20belt%20-map","status":"online"%7D',
            text: 'Belts & Chatelains'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"eyeglass%20OR%20monocole%20OR%20%5C"magnifying%20glass%5C"%20OR%20glasses%20OR%20sunglasses","status":"online"%7D',
            text: 'Eyeglasses & Spectacles'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"handbag%20OR%20purse%20OR%20%5C"shoulder%20bag%5C"%20OR%20%5C"messenger%20bag%5C"%20OR%20clutch","status":"online"%7D',
            text: 'Handbags & Purses'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"handkerchief%20OR%20%5C"pocket%20square%5C"","status":"online"%7D',
            text: 'Handkerchiefs & Pocket Squares'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"%5C"necktie%5C"%20OR%20%5C"neck%20tie%5C"%20OR%20%5C"bow%20tie%5C"%20OR%20%5C"bolo%20tie%5C"","status":"online"%7D',
            text: 'Neckties, Bow Ties & Bolo Ties'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"scarf%20OR%20shawl%20OR%20wrap","status":"online"%7D',
            text: 'Scarves, Wraps & Shawls'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"boots%20OR%20flats%20OR%20heels%20OR%20sandals","status":"online"%7D',
            text: 'Shoes'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"sunglasses","status":"online"%7D',
            text: 'Sunglasses'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"wallet","status":"online"%7D',
            text: 'Wallets'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Vanity Items',
        links: [{
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"comb%20OR%20brush","status":"online"%7D',
            text: 'Combs & Brushes'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"hand%20fan","status":"online"%7D',
            text: 'Hand Fans'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"hand%20mirror","status":"online"%7D',
            text: 'Hand Mirrors'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"perfume%20bottle","status":"online"%7D',
            text: 'Perfume Bottles'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"pill%20box","status":"online"%7D',
            text: 'Pill Boxes'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"%5C"straight%20razor%5C"%20OR%20%5C"safety%20razor%5C"%20OR%20%5C"shaving%20razor%5C"","status":"online"%7D',
            text: 'Razors'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"%5C"shaving%20mug%5C"%20OR%20%5C"shaving%20brush%5C"","status":"online"%7D',
            text: 'Shaving Mugs & Brushes'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"trinket%20box","status":"online"%7D',
            text: 'Trinket Boxes'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"vanity%20tray","status":"online"%7D',
            text: 'Vanity Trays'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Featured Designers',
        links: [{
            route: '/c/fashion/chanel/3/4017/',
            text: 'Chanel'
        }, {
            route: '/c/fashion/christian-dior/3/4461/',
            text: 'Christian Dior'
        }, {
            route: '/c/fashion/chloe/3/4385/',
            text: 'Chloe'
        }, {
            route: '/c/fashion/gucci/3/9450/',
            text: 'Gucci'
        }, {
            route: '/search?parameters=%7B"pageSize":24,"page":1,"sort":"-relevance","keyword":"hermes","status":"online"%7D',
            text: 'Hermes'
        }, {
            route: '/c/fashion/louis-vuitton/3/15385/',
            text: 'Louis Vuitton'
        }, {
            route: '/c/fashion/michael-kors/3/17295/',
            text: 'Michael Kors'
        }, {
            route: '/c/fashion/yves-saint-laurent/3/25497/',
            text: 'Yves Saint Laurent'
        }]
    }]
}];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Navigation/megaNavLinks.js
// module id = 3q2/
// module chunks = 46